import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "'Inter', 'Arial', sans-serif",
  },
  colors: {
    orange: "#FF7900",
    orangeLight: "#E79F1B",
    hoverOrange: "#ff4500",
    text: "#121212",
    background: "#f9f9f9",
    textLight: "#474747",
    blue: "#4684FF",
    green: "#32C025",
    lightGray: "#FBFBFB",
    red: "#FF012E",
    inpGray: "#f9f9f9",
    white: "#FFFFFF",
    lightGrey: "#ECECEC"
  },
});
